import React from 'react'
import {
  View,
} from 'react-native'
import { createStackNavigator } from '@react-navigation/stack'

import { useContent } from '@sart/content'
import { theme, colors } from '@sart/styles'
import { CompanyIcon } from '@sart/icons'

import { stackNavigationProps } from '../nagivationProps'

import Subscriptions from './Subscriptions'

const Stack = createStackNavigator()

function SubscriptionsStackNavigator() {

  const content = useContent()

  return(
    <Stack.Navigator
      initialRouteName='Subscriptions'
      screenOptions={{
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="Subscriptions"
        component={Subscriptions}
        options={{
          title: "Subscriptions",
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (<View style={{paddingLeft: 15}}>
            <CompanyIcon color={colors.srGreen} height={60} width={60} />
          </View>)
        }}
        
      />
    </Stack.Navigator>
  )
}

export default SubscriptionsStackNavigator